import type { RegionalOverviewDigitalTrapsProperties, RegionalOverviewPropertiesUnion } from './regional-overview.query.models';

export const isRegionalOverviewDigitalTrapsProperties = (
  properties: RegionalOverviewPropertiesUnion
): properties is RegionalOverviewDigitalTrapsProperties => {
  return 'provider' in properties && 'group' in properties && 'details' in properties;
};
